import { computed } from 'vue'

import { useEventBus } from '@/composables/event_bus'
import { releaseVersion } from '@/helpers/system'
import { useSystemStore } from '@/stores/system'
import { useUserStore } from '@/stores/user'

export function useReleaseNotesNotification() {
  const eventBus = useEventBus()
  const systemStore = useSystemStore()
  const userStore = useUserStore()

  const notes = computed(() => systemStore.release_notes.data.slice(0, 2))

  async function prepare(): Promise<boolean> {
    await systemStore.getLatestVersion()

    // do not show release notes until user has installed the latest version
    if (
      systemStore.latest_version.data === null ||
      systemStore.latest_version.data.version !== releaseVersion()
    ) {
      return false
    }

    const lastRead =
      userStore.settings.additional.last_read_release_notes_version
    await systemStore.getReleaseNotes(lastRead)
    if (!notes.value.length) {
      return false
    }

    await userStore
      .saveUserAdditionalSettings({
        last_read_release_notes_version: notes.value[0].version,
      })
      .catch((err) => {
        eventBus.emit('error', err)
      })

    // First login: no popup, only the newest version is remembered as read.
    return !!lastRead
  }

  return { prepare, notes }
}
